import React, { useState } from "react";
import img from "../assets/images/menu-ic.png";
const arr = [1, 2, 3, 4, 5, 6, 7, 8];
const buttons = [
  {
    title: "All",
  },
  { title: "Heroic", date: "1780-1936" },
  { title: "Legendary", date: "1780-1936" },
  { title: "Immortal", date: "1780-1936" },
  { title: "Bloodbath" },
  { title: "Training Camp" },
];
const Table = () => {
  const [toggle, setToggle] = useState(true);
  const [toggle2, setToggle2] = useState(true);
  const [toggle3, setToggle3] = useState(true);

  const handleClick = (id) => {
    if (id == "1") {
      setToggle(!toggle);
    } else if (id == "2") {
      setToggle2(!toggle2);
    } else {
      setToggle3(!toggle3);
    }
  };
  return (
    <>
      <div class="container mx-auto px-4 sm:px-16">
        <div class="py-8">
          <div className="flex gap-3 justify-center mt-4">
            {buttons.map((btn, index) => (
              <button
                key={index}
                className="rounded-[20px] bg-[#171717] px-6 py-1 text-[15px] font-semibold text-white hover:text-[grey] focus:outline-none"
              >
                <p>{btn.title}</p>
                <p className="text-[10px] text-[red]">{btn.date}</p>
              </button>
            ))}
          </div>

          <div className="flex gap-6 py-5">
            <div className="flex items-center gap-3 ">
              <button
                className={`transition ease-in-out duration-300 w-10 h-5 rounded-[20px] focus:outline-none ${
                  toggle ? "bg-gray-700" : "bg-[red]"
                }`}
                onClick={() => handleClick("1")}
              >
                <div
                  className={`w-5 h-5 bg-white rounded-full shadow transform transition-transform ${
                    toggle ? "translate-x-0" : "translate-x-full"
                  }`}
                ></div>
              </button>
              <div className="text-white ">Season Only</div>
            </div>
            <div className="flex items-center gap-3">
              <button
                className={`transition ease-in-out duration-300 w-10 h-5 rounded-[20px] focus:outline-none ${
                  toggle2 ? "bg-gray-700" : "bg-[red]"
                }`}
                onClick={() => handleClick("2")}
              >
                <div
                  className={`w-5 h-5 bg-white rounded-full shadow transform transition-transform ${
                    toggle2 ? "translate-x-0" : "translate-x-full"
                  }`}
                ></div>
              </button>
              <div className="text-white ">Season Only</div>
            </div>
            <div className="flex items-center gap-3  ">
              <button
                className={`transition ease-in-out duration-300 w-10 h-5 rounded-[20px] focus:outline-none ${
                  toggle3 ? "bg-gray-700" : "bg-[red]"
                }`}
                onClick={() => handleClick("3")}
              >
                <div
                  className={`w-5 h-5 bg-white rounded-full shadow transform transition-transform ${
                    toggle3 ? "translate-x-0" : "translate-x-full"
                  }`}
                ></div>
              </button>
              <div className="text-white ">Season Only</div>
            </div>
          </div>

          <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div class="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
              <table class="min-w-full leading-normal">
                <thead className="text-white">
                  <tr>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Name
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Event
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      ID
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Class
                    </th>
                    {/* <th class="px-5 py-3 text-[red]"></th> */}

                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Entry Fee
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Piza Pool
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Registered
                    </th>
                    <th class="px-5 py-3 text-[red] text-left text-xs font-semibold text-gray-700  tracking-wider">
                      Fights In
                    </th>
                    <th class="px-5 py-3 text-[red]"></th>
                  </tr>
                </thead>
                <tbody className="">
                  {arr.map((data, index) => {
                    return (
                      <>
                        <tr className="mb-4 rounded-full">
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">
                              Molly Sanders
                            </p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">$20,000</p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">
                              Sept 28, 2019
                            </p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <span class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                              <span
                                aria-hidden
                                class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                              ></span>
                              <span class="relative">Paid</span>
                            </span>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">
                              Molly Sanders
                            </p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">$20,000</p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <p class="text-white whitespace-no-wrap">
                              Sept 28, 2019
                            </p>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm">
                            <span class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                              <span
                                aria-hidden
                                class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                              ></span>
                              <span class="relative">Paid</span>
                            </span>
                          </td>
                          <td class="px-5 py-3  bg-[#171717] text-sm text-right">
                            <button
                              type="button"
                              class="inline-block text-gray-500 hover:text-gray-700"
                            >
                              <svg
                                class="inline-block h-6 w-6 fill-current"
                                viewBox="0 0 24 24"
                              >
                                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Table;
